export class Address {
  id?: number;
  postalCode: string;
  city: string;
  street: string;
  houseNumber: string;
  country?: string;
  latitude?: string;
  longitude?: string;

  constructor(formValue?: Partial<Address>) {
    Object.assign(this, formValue);
  }

  static buildAddressQuery(parts: {
    street?: string;
    houseNumber?: string;
    postalCode?: string;
    city?: string;
    country?: string;
  }): string {
    const streetPart = [parts.street, parts.houseNumber]
      .filter(Boolean)
      .join(" ")
      .trim();
    const cityPart = [parts.postalCode, parts.city]
      .filter(Boolean)
      .join(" ")
      .trim();
    const countryPart = parts.country?.trim();
    const base = [streetPart, cityPart].filter(Boolean).join(", ");
    if (!base) return countryPart ?? "";
    return countryPart ? `${base}, ${countryPart}` : base;
  }
}
